import { useMutation, useQueryClient } from 'react-query';

// our api
import localAxiosInstance from 'services/API/LocalAPI';

// our query keys
import { KEY_ACTION_QUALIFIERS } from 'shared/query-keys';

// our endpoints
import { updateKeyActionQualifierUrl } from 'shared/api-urls';

// our constants
import { DEFAULT_STALE_TIME_FIVE_MINUTES } from 'shared/constants';

function useMutateChangeKeyActionQualifier() {
	const queryClient = useQueryClient();

	return useMutation(
		async (updateKeyActionQualifierPayload) => {
			const response = await localAxiosInstance.post(
				updateKeyActionQualifierUrl,
				updateKeyActionQualifierPayload
			);
			return response.data;
		},
		{
			staleTime: DEFAULT_STALE_TIME_FIVE_MINUTES,
			onSuccess: async () => {
				queryClient.invalidateQueries(KEY_ACTION_QUALIFIERS);
			}
		}
	);
}

export default useMutateChangeKeyActionQualifier;
